/* eslint-disable css-modules/no-unused-class  */
import { useEffect, useState, FC } from 'react';
import { useSelector } from 'react-redux';
import { selectIsLeanUser, selectToken, selectUserUuid } from '@redux/slices/userSlice';
import { useGetCourseData } from '@queries/platform/course';
import { useGetUserProfilePicture } from '@queries/platform/aws';
import { useGetUserInfo } from '@queries/platform/login';
import { getTags } from 'utils';
import { translate } from 'translations';
import { useNavigate } from 'react-router-dom';
import Course from './course';

const CourseContainer: FC<{ onContactUsClick: Function }> = ({ onContactUsClick }: { onContactUsClick: Function }) => {
    const courseUuidParam = new URLSearchParams(window.location.search).get('courseUuid');
    const userUuid = useSelector(selectUserUuid);
    const isLeanUser = useSelector(selectIsLeanUser);
    const [course, setCourse] = useState<any>(null);
    const [courseLessons, setCourseLessons] = useState<any>(null);
    const [quiz, setQuiz] = useState<any>(null);
    const [unavailableCourseLessons, setUnavailableCourseLessons] = useState<any>(null);
    const navigate = useNavigate();
    const token = useSelector(selectToken);

    const onBackRoute = '/course';

    const { data: courseData, isLoading: isCourseLoading } = useGetCourseData(courseUuidParam || '', token);
    const { data: userProfilePicture } = useGetUserProfilePicture(userUuid);
    const { data: userInfoData } = useGetUserInfo(userUuid);

    useEffect(() => {
        if (!courseData?.course) return;
        const { course, lessons, quiz, units } = courseData;
        const courseTmp = {
            uuid: course.uuid,
            displayName: course.displayName,
            description: course.description,
            courseImageSrc: course.iconUrl,
            nextLessonUrl: course.nextLessonUrl,
            userCompletionRate: course.completionPercentage,
            coins: course.coins,
            units: units && units.length > 0 ? units : undefined
        };
        const lessonsTmp = {
            lessons: lessons.map((lesson: any) => {
                return {
                    uuid: lesson.uuid,
                    displayName: lesson.displayName,
                    description: lesson.description,
                    name: lesson.name,
                    isCompleted: lesson.isCompleted,
                    lessonUrl: lesson.url,
                    iconUrl: lesson.iconUrl,
                    duration: lesson?.duration,
                    activeOnLean: lesson?.activeOnLean,
                    links: getTags(lesson),
                    tags: lesson.tags?.map((tag: any) => tag.displayName),
                    earnedPoints: lesson.earnedPoints,
                    doneRecently: lesson.doneRecently,
                    score: lesson.doneRecently ? undefined : lesson.potentialPoints,
                    systemCourseDisplayName: lesson.systemCourseDisplayName,
                    customCourseDisplayNames: lesson.customCourseDisplayNames,
                    tagsNames: lesson.tags?.map((tag: any) => tag.name)
                };
            })
        };

        setCourse(courseTmp);
        quiz && setQuiz(courseData.quiz);

        if (isLeanUser) {
            const availableLessons = lessonsTmp.lessons.filter((lesson: any) => lesson.activeOnLean);
            const unavailableLessons = lessonsTmp.lessons.filter((lesson: any) => !lesson.activeOnLean);
            setCourseLessons(availableLessons);
            setUnavailableCourseLessons(unavailableLessons);
        } else {
            setCourseLessons(lessonsTmp.lessons);
        }
    }, [courseData, isCourseLoading, isLeanUser]);

    return (
        <Course
            isLoading={isCourseLoading || !course}
            course={course}
            userNickname={userInfoData?.nickname || ''}
            userAvatar={userProfilePicture?.url}
            courseLessons={courseLessons}
            unavailableCourseLessons={unavailableCourseLessons}
            onBack={(): void => navigate(onBackRoute)}
            onContactUsClick={onContactUsClick}
            quiz={quiz}
        />
    );
};

export default CourseContainer;
